module.exports = __webpack_public_path__ + "static/media/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon.ico
// module id = 816
// module chunks = 0